export default __webpack_public_path__ + "static/media/person-inactive.39800b74.svg";